window.addEventListener("load", function () {
  let trueHeight = window.innerHeight;
  let trueHeightsHeader =  trueHeight - 100;

  let setHeights = document.querySelectorAll('.true-height');
  setHeights.forEach(function(item,i){
    item.style.height = trueHeightsHeader + "px";
  });
});

const swiper = new Swiper('.swiper-desktop', {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  }
});

swiper.on('slideChange', function () {
  const totalSlides = swiper.slides.length;
  const currentIndex = swiper.realIndex;
  const nextButton = document.querySelector('.swiper-button-next');
  const prevButton = document.querySelector('.swiper-button-prev');

  if (currentIndex === totalSlides - 1) {
    nextButton.classList.add('hide');
    prevButton.classList.add('hide');
  } else {
    nextButton.classList.remove('hide');
    prevButton.classList.remove('hide');
  }
});

const swiperTwo = new Swiper('.swiper-mobile', {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

swiperTwo.on('slideChange', function () {
  const currentIndex = swiperTwo.realIndex;

  //console.log(currentIndex);
  let checkSS25 = document.querySelector("#shopify-section-lb-ss25-mobile");


  if(!checkSS25){ 
    if (currentIndex == 0) {
      document.querySelector('.controls span').classList.remove('hide');
    } else {
      document.querySelector('.controls span').classList.add('hide');
    }
  }

});
